import styled from 'react-emotion';
import { Menu } from 'react-contexify';
export var StyledMenu = styled(Menu)({
    '&&': {
        minWidth: 150
    }
});
//# sourceMappingURL=ContextMenu.Styles.js.map